// extracted by mini-css-extract-plugin
export var askAiIcon = "_m8-j";
export var category = "_m8-9";
export var categoryHeader = "_m8-e";
export var container = "_m8-0";
export var group = "_m8-a";
export var groupItems = "_m8-f";
export var groupSeparator = "_m8-k";
export var loading = "_m8-1";
export var noResults = "_m8-3";
export var placeholder = "_m8-2";
export var resultContent = "_m8-5";
export var resultIcon = "_m8-c";
export var resultItem = "_m8-g";
export var resultMeta = "_m8-8";
export var resultSubtitle = "_m8-7";
export var resultSuffix = "_m8-i";
export var resultTitle = "_m8-6";
export var resultsList = "_m8-4";
export var searchGroup = "_m8-d";
export var selected = "_m8-h";
export var subgroup = "_m8-b";